import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class ErrorHandlingService {
  public setErrors(errors: { [key: string]: any }, form: UntypedFormGroup): void {
    if (!errors || !form) return;
    Object.entries(errors).forEach(([key, value]) => this._setError(key, value, form));
    Object.values(form.controls).forEach((control) => control?.markAsTouched());
  }

  private _setError(controlName: string, error: string | string[] | { [key: string]: any }, form: UntypedFormGroup): void {
    const custom = !!error && error instanceof Array ? error[0] : error;
    if (typeof custom === 'object') return this.setErrors(custom, form?.get(controlName) as UntypedFormGroup);
    else if (form.get(controlName)) form.get(controlName).setErrors({ custom });
    else form.setErrors({ [controlName]: custom });
  }
}
